// 전광판 창은 서버에 저장된 대진표를 주기적으로 다시 불러와 갱신한다.
export const BRACKET_DISPLAY_POLL_MS = 5000;

export function openBracketDisplayWindow(tournamentId) {
  const params = new URLSearchParams({ tournamentId: String(tournamentId) });
  const url = `${window.location.origin}${process.env.PUBLIC_URL}/tournament/display?${params.toString()}`;
  // 전광판은 공개 조회 API 를 쓰므로 로그인이 필요 없다.
  return window.open(
    url,
    'tournament-bracket-display',
    'width=1920,height=1080,menubar=no,toolbar=no,location=no,status=no'
  );
}
